import {ApplicationDashboard} from "@flexinet/ui-components";
import {structure} from "../config";
import {useVerifiedPermissions} from '@flexinet/auth-components';

export const PortalDashboard = () => {

    const {allowedActions} = useVerifiedPermissions()

    // FNP-1718: build a filtered COPY. Assigning back into the module-level
    // `structure` made the filter permanent, so a render before AVP answered
    // (allowedActions still empty) removed every widget until a full reload,
    // and the dashboard showed a blank main panel.
    const visible = {
        ...structure,
        columns: structure.columns.map(column => ({
            ...column,
            items: column.items.filter(item => allowedActions.includes(item.rbac as string)),
        })),
    }

    return (
        <ApplicationDashboard structure={visible}/>
    );
};
